module.exports = __webpack_public_path__ + "img/edit_event_step4_on.f69f2a87.png";